import React from 'react';
import t from 'prop-types';
import normalizarTexto from './normalizar-texto';

var Texto = function Texto(_ref) {
  var texto = _ref.texto;
  var textoNormalizado = normalizarTexto(texto);
  return React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: textoNormalizado
    }
  });
};

Texto.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.string
} : {};
export default Texto;